import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { ListaPrecoTabela, Tipo } from 'app/shared/interfaces/lista-preco-tabela';
import { ListaPreco } from 'app/shared/interfaces/lista-preco';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { TabelaTablePopupComponent } from '../tabela-popup-table/tabela-table-popup.component';
import { ListaPrecoService } from 'app/shared/services/lista-preco.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { MatPaginator } from '@angular/material/paginator';
import { PageResult } from 'app/shared/interfaces/page-result';
import { uuid } from 'ngx-custom-validators/src/app/uuid/validator';
import { validateBasis } from '@angular/flex-layout';
import { importType } from '@angular/compiler/src/output/output_ast';
import { Meta } from '@angular/platform-browser';
import { UUIDValidator } from 'ngx-custom-validators/src/app/uuid/directive';
import { url } from 'ngx-custom-validators/src/app/url/validator';
import { ListaPrecoTabelaService } from 'app/shared/services/lista-preco-tabela.service';

@Component({
  selector: 'app-preco-table-popup',
  templateUrl: 'preco-table-popup.component.html',
  styleUrls: ['preco-table-popup.component.scss']
})
export class PrecoTablePopupComponent implements OnInit {
  public itemForm: FormGroup;
  public itemDiretivasFatForm: FormGroup;

  precos: PrecoTablePopupComponent[];
  preco: PrecoTablePopupComponent;
  tipo: Tipo[];
  cep: any;
  isLoading = false;
  isLoadingGrupo = false;
  errorMsg: string;


  selected = [];

  pageObject$: BehaviorSubject<PageResult<ListaPrecoTabela>> = new BehaviorSubject<PageResult<ListaPrecoTabela>>(null);


  @ViewChild('table') table: DatatableComponent;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;


  rows = [];
  rowIndex;
  isEditable = {};

  maskFone = {
    mask: '(00) {*}0000-0000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCep = {
    mask: '00000-000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCpf = {
    mask: '000.000.000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCnpj = {
    mask: 'SS.SSS.SSS/SSSS-00',
    definitions: { S: /[0-9A-Za-z]/ },
    prepare: (str: string) => (str || '').toUpperCase(),
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };
  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };
  maskLower = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toLowerCase()
  };

  maskEmail = {
    mask: /^\S*@?\S*$/,
    prepare: (email: any) => email.toLowerCase()
  };


  page = 1;
  length = 0;
  pageSize = 10;
  pageEvent = null;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  listaPreco: ListaPreco;


  // public itemForm: FormGroup
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PrecoTablePopupComponent>,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private loader: AppLoaderService,
    private tabelaPrecoService: ListaPrecoTabelaService,
  ) { }

  ngOnInit() {
    this.buildItemForm(this.data.payload)
  }

  buildItemForm(item: ListaPreco) {
    this.itemForm = this.fb.group({
      id: [item.id],
      uuid: [item.uuid],
      codigo: [item.codigo, [Validators.required]],
      desativado: [item.desativado],
      descricao: [item.descricao, [Validators.required]],
      tabela: [item.tabela],
      indice: [item.indice],
      percentualAcrescimo: [item.percentualAcrescimo],
      listaUUID: [item.listaUUID],
      tipo: [item.tipo],
      statusSync: [item.statusSync],
      logErro: [item.logErro],
    })
    this.listaPreco = item;
  }

  submit() {
    // console.log( this.itemForm.value.endereco);
    // this.itemForm.value.inscricaoFederal = this.itemForm.value.cpfCnpj;
    // this.itemForm.value.cpf = this.itemForm.value.cpfCnpj;
    // this.itemForm.value.rg = this.itemForm.value.rgInscricao;
    // this.itemForm.value.inscricaoEstadual = this.itemForm.value.rgInscricao;
    this.dialogRef.close(this.itemForm.value)
  }

  /**
   * Retorna a página requerida,
   * @param page numero da página requisitada, primeira página é 1
   * @param pageSize quantidade de itens a serem retornados
   */
  getPage(page: number, pageSize: number) {
    this.tabelaPrecoService.getTabelaPage(page, pageSize).subscribe(val => this.pageObject$.next(val));
  }

  /**
   * Retorna a página da pesquisa,
   * @param search valor a ser pesquisada
   * @param page numero da página requisitada, primeira página é 1
   * @param pageSize quantidade de itens a serem retornados
   */
  getSearchPage(search: string, page: number, pageSize: number) {
    if (page === 1) {
      this.paginator.firstPage();
    }
    if (search === null || search === undefined || search.length === 0) {
      this.getPage(1, this.pageSize);
    } else {
      this.tabelaPrecoService.getTabelaPageSearch(this.listaPreco.id,  page, pageSize, search).subscribe(val => this.pageObject$.next(val));
    }
  }

  openPopUp(data: any = {}, isNew?, idLista?) {
    const title = isNew ? 'Nova Tabela' : 'Alterar Tabela';
    data.listaId = idLista;
    const dialogRef: MatDialogRef<any> = this.dialog.open(TabelaTablePopupComponent, {
      width: '1024px',
      disableClose: true,
      data: { title: title, payload: data }
    })

    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          // If user press cancel
          return;
        }
        this.loader.open();
        if (res.id === null) {
          res.id = 0;
        }
        if (res.listaUUID === null) {
          res.listaUUID = res.listaUUID
        }

        this.tabelaPrecoService.saveOrUpdateTabela(res)
          .subscribe(data => {
            this.getSearchPage(data.descricao, 1, this.pageSize);
            this.loader.close();
            this.snack.open('Tabela Salva com sucesso!', 'OK', { duration: 5500 })
          }, (err: HttpErrorResponse) => {
            this.loader.close();
            this.snack.open('Erro ao salvar a tabela!', 'ERRO', { duration: 5500 });
          })
      })
  }


  close() {
    this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close(false);
        }
      });
  }

}
